// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-announcement .no-data-title{font-size:2rem}.section-announcement .el-row{margin-bottom:20px}.section-announcement .el-row:last-child{margin-bottom:0}.section-announcement .el-link,.section-announcement .el-link .el-link--inner{width:100%!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
